import { observer } from "mobx-react-lite";

import { Group } from "@/components/expression/utils/groups/Group";
import { NodeStyleProvider } from "@/components/expression/utils/NodeStyleProvider";
import { useCurrentCursorContext } from "@/components/input/CursorContextProvider";
import { SuggestionsProvider } from "@/components/suggestions/SuggestionsProvider";

import type { ExpressionComponent } from "@/components/expression/types";

export const UnitNode: ExpressionComponent<"unit"> = observer(function UnitNode({ node }) {
  const { doc } = node;
  const { cursor } = useCurrentCursorContext(doc);
  const isFocused = cursor?.isOnNode(node);

  if (!node.inlineNode) {
    return null;
  }

  return (
    <SuggestionsProvider accept={["input", "unit", "operatorSymbol", "operator", "plainText"]}>
      <NodeStyleProvider text="unit" view="text">
        <Group
          node={node}
          parameters={[node.inlineNode]}
          openingSymbol="["
          closingSymbol="]"
          disabled
          hideParentheses={!isFocused}
          compensateBracketWidthRight={0}
        />
      </NodeStyleProvider>
    </SuggestionsProvider>
  );
});
